import styles from './InvoiceSortFilter.module.scss';
import { InvoiceSortOptions, Sort } from 'state';
import { DropDownButton } from 'components/Buttons/DropDownButton/DropDownButton';

type Props = {
    invoiceSort: Sort | undefined,
    onInvoiceSortChange: (value: Sort) => void
};

const InvoiceSortFilter = ({ invoiceSort, onInvoiceSortChange: onStatusChange }: Props) => (
    <DropDownButton 
        className={styles.control}
        items={InvoiceSortOptions}
        onItemClick={(e) => onStatusChange(e.item === 'All' ? undefined : e.item)}
        tabIndex={0}
        text={<span className={styles.text}>{invoiceSort?.text}</span>}
    />
);
export default InvoiceSortFilter;